import {Search} from 'platform/components';
import {Box} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {handleDropdownStickyRegionKeyDown} from '../utils/handleDropdownStickyRegionKeyDown';

interface SavedFiltersDropdownSearchProps extends TestIdProps {
  value: string | null;
  placeholder: string;
  onChange: (value: string | null) => void;
}

export function SavedFiltersDropdownSearch(props: SavedFiltersDropdownSearchProps) {
  return (
    <Box
      flexShrink={0}
      paddingVertical={2}
      borderBottom="1px solid"
      borderColor="general.separator"
      backgroundColor="general.white"
    >
      <div onKeyDown={handleDropdownStickyRegionKeyDown}>
        <Search
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
          data-testid={suffixTestId('search', props)}
        />
      </div>
    </Box>
  );
}
